import { __exports as d } from "../_virtual/index.esm.js";
import B from "react";
var z;
function D() {
  if (z) return d;
  z = 1;
  var f = B;
  function C(i) {
    return i && typeof i == "object" && "default" in i ? i : { default: i };
  }
  var _ = /* @__PURE__ */ C(f);
  function b(i, n) {
    for (var s = 0; s < n.length; s++) {
      var e = n[s];
      e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(i, e.key, e);
    }
  }
  function j(i, n, s) {
    return n && b(i.prototype, n), i;
  }
  var p = typeof process < "u" && process.env && process.env.NODE_ENV === "production", S = function(i) {
    return Object.prototype.toString.call(i) === "[object String]";
  }, A = /* @__PURE__ */ (function() {
    function i(s) {
      var e = s === void 0 ? {} : s, t = e.name, r = t === void 0 ? "stylesheet" : t, o = e.optimizeForSpeed, u = o === void 0 ? p : o;
      l(S(r), "`name` must be a string"), this._name = r, this._deletedRulePlaceholder = "#" + r + "-deleted-rule____{}", l(typeof u == "boolean", "`optimizeForSpeed` must be a boolean"), this._optimizeForSpeed = u, this._serverSheet = void 0, this._tags = [], this._injected = !1, this._rulesCount = 0;
      var h = typeof window < "u" && document.querySelector('meta[property="csp-nonce"]');
      this._nonce = h ? h.getAttribute("content") : null;
    }
    var n = i.prototype;
    return n.setOptimizeForSpeed = function(e) {
      l(typeof e == "boolean", "`setOptimizeForSpeed` accepts a boolean"), l(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted"), this.flush(), this._optimizeForSpeed = e, this.inject();
    }, n.isOptimizeForSpeed = function() {
      return this._optimizeForSpeed;
    }, n.inject = function() {
      var e = this;
      if (l(!this._injected, "sheet already injected"), this._injected = !0, typeof window < "u" && this._optimizeForSpeed) {
        this._tags[0] = this.makeStyleTag(this._name), this._optimizeForSpeed = "insertRule" in this.getSheet(), this._optimizeForSpeed || (p || console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode."), this.flush(), this._injected = !0);
        return;
      }
      this._serverSheet = {
        cssRules: [],
        insertRule: function(t, r) {
          return typeof r == "number" ? e._serverSheet.cssRules[r] = {
            cssText: t
          } : e._serverSheet.cssRules.push({
            cssText: t
          }), r;
        },
        deleteRule: function(t) {
          e._serverSheet.cssRules[t] = null;
        }
      };
    }, n.getSheetForTag = function(e) {
      if (e.sheet)
        return e.sheet;
      for (var t = 0; t < document.styleSheets.length; t++)
        if (document.styleSheets[t].ownerNode === e)
          return document.styleSheets[t];
    }, n.getSheet = function() {
      return this.getSheetForTag(this._tags[this._tags.length - 1]);
    }, n.insertRule = function(e, t) {
      if (l(S(e), "`insertRule` accepts only strings"), typeof window > "u")
        return typeof t != "number" && (t = this._serverSheet.cssRules.length), this._serverSheet.insertRule(e, t), this._rulesCount++;
      if (this._optimizeForSpeed) {
        var r = this.getSheet();
        typeof t != "number" && (t = r.cssRules.length);
        try {
          r.insertRule(e, t);
        } catch {
          return p || console.warn(`StyleSheet: illegal rule: 

` + e + `

See https://stackoverflow.com/q/20007992 for more info`), -1;
        }
      } else {
        var o = this._tags[t];
        this._tags.push(this.makeStyleTag(this._name, e, o));
      }
      return this._rulesCount++;
    }, n.replaceRule = function(e, t) {
      if (this._optimizeForSpeed || typeof window > "u") {
        var r = typeof window < "u" ? this.getSheet() : this._serverSheet;
        if (t.trim() || (t = this._deletedRulePlaceholder), !r.cssRules[e])
          return e;
        r.deleteRule(e);
        try {
          r.insertRule(t, e);
        } catch {
          p || console.warn(`StyleSheet: illegal rule: 

` + t + `

See https://stackoverflow.com/q/20007992 for more info`), r.insertRule(this._deletedRulePlaceholder, e);
        }
      } else {
        var o = this._tags[e];
        l(o, "old rule at index `" + e + "` not found"), o.textContent = t;
      }
      return e;
    }, n.deleteRule = function(e) {
      if (typeof window > "u") {
        this._serverSheet.deleteRule(e);
        return;
      }
      if (this._optimizeForSpeed)
        this.replaceRule(e, "");
      else {
        var t = this._tags[e];
        l(t, "rule at index `" + e + "` not found"), t.parentNode.removeChild(t), this._tags[e] = null;
      }
    }, n.flush = function() {
      this._injected = !1, this._rulesCount = 0, typeof window < "u" ? (this._tags.forEach(function(e) {
        return e && e.parentNode.removeChild(e);
      }), this._tags = []) : this._serverSheet.cssRules = [];
    }, n.cssRules = function() {
      var e = this;
      return typeof window > "u" ? this._serverSheet.cssRules : this._tags.reduce(function(t, r) {
        return r ? t = t.concat(Array.prototype.map.call(e.getSheetForTag(r).cssRules, function(o) {
          return o.cssText === e._deletedRulePlaceholder ? null : o;
        })) : t.push(null), t;
      }, []);
    }, n.makeStyleTag = function(e, t, r) {
      t && l(S(t), "makeStyleTag accepts only strings as second parameter");
      var o = document.createElement("style");
      this._nonce && o.setAttribute("nonce", this._nonce), o.type = "text/css", o.setAttribute("data-" + e, ""), t && o.appendChild(document.createTextNode(t));
      var u = document.head || document.getElementsByTagName("head")[0];
      return r ? u.insertBefore(o, r) : u.appendChild(o), o;
    }, j(i, [
      {
        key: "length",
        get: function() {
          return this._rulesCount;
        }
      }
    ]), i;
  })();
  function l(i, n) {
    if (!i)
      throw new Error("StyleSheet: " + n + ".");
  }
  function T(i) {
    for (var n = 5381, s = i.length; s; )
      n = n * 33 ^ i.charCodeAt(--s);
    return n >>> 0;
  }
  var k = T, O = function(i) {
    return i.replace(/\/style/gi, "\\/style");
  }, a = {};
  function m(i, n) {
    if (!n)
      return "jsx-" + i;
    var s = String(n), e = i + s;
    return a[e] || (a[e] = "jsx-" + k(i + "-" + s)), a[e];
  }
  function g(i, n) {
    var s = /__jsx-style-dynamic-selector/g;
    typeof window > "u" && (n = O(n));
    var e = i + n;
    return a[e] || (a[e] = n.replace(s, i)), a[e];
  }
  function E(i, n) {
    return n === void 0 && (n = {}), i.map(function(s) {
      var e = s[0], t = s[1];
      return /* @__PURE__ */ _.default.createElement("style", {
        id: "__" + e,
        // Avoid warnings upon render with a key
        key: "__" + e,
        nonce: n.nonce ? n.nonce : void 0,
        dangerouslySetInnerHTML: {
          __html: t
        }
      });
    });
  }
  var I = /* @__PURE__ */ (function() {
    function i(s) {
      var e = s === void 0 ? {} : s, t = e.styleSheet, r = t === void 0 ? null : t, o = e.optimizeForSpeed, u = o === void 0 ? !1 : o;
      this._sheet = r || new A({
        name: "styled-jsx",
        optimizeForSpeed: u
      }), this._sheet.inject(), r && typeof u == "boolean" && (this._sheet.setOptimizeForSpeed(u), this._optimizeForSpeed = this._sheet.isOptimizeForSpeed()), this._fromServer = void 0, this._indices = {}, this._instancesCounts = {};
    }
    var n = i.prototype;
    return n.add = function(e) {
      var t = this;
      this._optimizeForSpeed === void 0 && (this._optimizeForSpeed = Array.isArray(e.children), this._sheet.setOptimizeForSpeed(this._optimizeForSpeed), this._optimizeForSpeed = this._sheet.isOptimizeForSpeed()), typeof window < "u" && !this._fromServer && (this._fromServer = this.selectFromServer(), this._instancesCounts = Object.keys(this._fromServer).reduce(function(c, x) {
        return c[x] = 0, c;
      }, {}));
      var r = this.getIdAndRules(e), o = r.styleId, u = r.rules;
      if (o in this._instancesCounts) {
        this._instancesCounts[o] += 1;
        return;
      }
      var h = u.map(function(c) {
        return t._sheet.insertRule(c);
      }).filter(function(c) {
        return c !== -1;
      });
      this._indices[o] = h, this._instancesCounts[o] = 1;
    }, n.remove = function(e) {
      var t = this, r = this.getIdAndRules(e).styleId;
      if (N(r in this._instancesCounts, "styleId: `" + r + "` not found"), this._instancesCounts[r] -= 1, this._instancesCounts[r] < 1) {
        var o = this._fromServer && this._fromServer[r];
        o ? (o.parentNode.removeChild(o), delete this._fromServer[r]) : (this._indices[r].forEach(function(u) {
          return t._sheet.deleteRule(u);
        }), delete this._indices[r]), delete this._instancesCounts[r];
      }
    }, n.update = function(e, t) {
      this.add(t), this.remove(e);
    }, n.flush = function() {
      this._sheet.flush(), this._sheet.inject(), this._fromServer = void 0, this._indices = {}, this._instancesCounts = {};
    }, n.cssRules = function() {
      var e = this, t = this._fromServer ? Object.keys(this._fromServer).map(function(o) {
        return [
          o,
          e._fromServer[o]
        ];
      }) : [], r = this._sheet.cssRules();
      return t.concat(Object.keys(this._indices).map(function(o) {
        return [
          o,
          e._indices[o].map(function(u) {
            return r[u].cssText;
          }).join(e._optimizeForSpeed ? "" : `
`)
        ];
      }).filter(function(o) {
        return !!o[1];
      }));
    }, n.styles = function(e) {
      return E(this.cssRules(), e);
    }, n.getIdAndRules = function(e) {
      var t = e.children, r = e.dynamic, o = e.id;
      if (r) {
        var u = m(o, r);
        return {
          styleId: u,
          rules: Array.isArray(t) ? t.map(function(h) {
            return g(u, h);
          }) : [
            g(u, t)
          ]
        };
      }
      return {
        styleId: m(o),
        rules: Array.isArray(t) ? t : [
          t
        ]
      };
    }, n.selectFromServer = function() {
      var e = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
      return e.reduce(function(t, r) {
        var o = r.id.slice(2);
        return t[o] = r, t;
      }, {});
    }, i;
  })();
  function N(i, n) {
    if (!i)
      throw new Error("StyleSheetRegistry: " + n + ".");
  }
  var y = /* @__PURE__ */ f.createContext(null);
  y.displayName = "StyleSheetContext";
  function v() {
    return new I();
  }
  function P(i) {
    var n = i.registry, s = i.children, e = f.useContext(y), t = f.useState(function() {
      return e || n || v();
    }), r = t[0];
    return /* @__PURE__ */ _.default.createElement(y.Provider, {
      value: r
    }, s);
  }
  function R() {
    return f.useContext(y);
  }
  var q = _.default.useInsertionEffect || _.default.useLayoutEffect, w = typeof window < "u" ? v() : void 0;
  function F(i) {
    var n = w || R();
    return n ? typeof window > "u" ? (n.add(i), null) : (q(function() {
      return n.add(i), function() {
        n.remove(i);
      };
    }, [
      i.id,
      String(i.dynamic)
    ]), null) : null;
  }
  return F.dynamic = function(i) {
    return i.map(function(n) {
      var s = n[0], e = n[1];
      return m(s, e);
    }).join(" ");
  }, d.StyleRegistry = P, d.createStyleRegistry = v, d.style = F, d.useStyleRegistry = R, d;
}
export {
  D as __require
};
